import ControlsAreaLayout from './ControlsAreaLayout';

export default ControlsAreaLayout;
